<div class="br-main-container">
  <div class="br-container" *ngIf="image">
    <div class="br-container__img-container">
      <img
        id="imgResult"
        [class]="
          type === 'rostro'
            ? isVertical
              ? 'face-measures'
              : 'document-measures'
            : 'document-measures'
        "
        [src]="image"
        alt="result"
      />
    </div>
    <div class="br-container__title">{{ results_texts.title }}</div>
    <div class="br-container__text">{{ results_texts.subtitle }}</div>
    <div class="br-container__btn-container">
      <p class="br-container__link-button" id="btn-repeat" (click)="goRepeat()" (keydown)="goRepeat()">
        {{ results_texts.btnRedo[route] }}
      </p>

      <button
        class="br-container__btn-container-btn btn btn-degraded blue"
        id="btn-continue"
        (click)="saveImage()"
      >
        {{ results_texts.btnContinue }}
      </button>
    </div>
  </div>
</div>
